import React from 'react';
import styles from './PageHeader.scss';

interface IPageHeader {
  title: string;
  subtitle?: string;
}

const PageHeader: React.FC<IPageHeader> = ({ title, subtitle }) => {
  return (
    <header className={styles.pageHeader}>
      <h1 className={styles.title}>{title}</h1>
      {subtitle ? <div className={styles.subtitle}>{subtitle}</div> : null}
    </header>
  );
};

export default PageHeader;
